import React from 'react'
import { BiArrowToRight } from 'react-icons/bi'
import { Link } from 'react-router-dom'

const TeamContent = () => {
  return (
    <>
      <section class="space-ptb bg-light">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 col-md-10 text-center">           
            <div class="section-title">
              <h2>Our Management</h2>             
            </div>            
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-6 mb-4 mb-md-0">
            <div class="team">
              <div class="team-img">
                <img class="img-fluid" src="images/team/founder-new.png" alt="" />
              </div>
              <div class="team-info">
                <a href="teachers-single.html" class="team-name">Late Shri Puran Singh</a>
                <p class="team-leader">Our Founder</p>
                <div class="d-flex justify-content-center">
                    <Link to={'/Founder'} class="d-flex align-items-center font-weight-normal">read more <BiArrowToRight /> </Link>
                </div>         
              </div>
            </div>
            
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6 mb-4 mb-md-0">
            <div class="team">
                <img class="img-fluid" src="images/team/managernew.png" alt="" />
              <div class="team-info">
                <a href="teachers-single.html" class="team-name">DR. Brajendra Singh</a>
                <p class="team-leader">Manager</p>
                <div class="d-flex justify-content-center">
                    <Link to={'/Manager'} class="d-flex align-items-center font-weight-normal">read more <BiArrowToRight /> </Link>
                </div>  
              </div>
            </div>
            
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6">
            <div class="team">
              <div class="team-img">
                <img class="img-fluid" src="images/team/principal-new.png" alt="" />
              </div>
              <div class="team-info">
                <a href="teachers-single.html" class="team-name">Mrs. Sharmila Singh</a>
                <p class="team-leader">Principal</p>
                <div class="d-flex justify-content-center">
                    <Link to={'/Principal'} class="d-flex align-items-center font-weight-normal">read more <BiArrowToRight /> </Link>
                </div> 
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default TeamContent
